import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import Loader from 'react-loader-spinner';
import TextField from '@material-ui/core/TextField';

import { ReactSVG } from 'react-svg';
import Images from '../../Theme/Images';
import FormHelperText from '@material-ui/core/FormHelperText';
import { adminStyles } from '../../Styles/adminStyles';

@inject('adminStore')
@observer
class BlockDialog extends React.Component {
    state = {
        validationErrors: {}, ip: '', domain: ''
    }

    componentWillReceiveProps(nextprops) {
        this.setState({ ip: nextprops.ip, validationErrors: {}, domain: nextprops.domain })
    }

    onClickBlock = (e) => {
        const { type } = this.props;
        e.preventDefault();
        const { ip, validationErrors, domain } = this.state;
        let ipRegex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        console.log(this.props.ip != '', this.props.ip,this.props.domain)
        if (this.props.filter === 'IP') {
            console.log("up noly")
            if (!ip || !ipRegex.test(ip)) {
                validationErrors['ip'] = "Please enter a valid IP!";
                this.setState({ validationErrors });
            }
            else {
                delete validationErrors['ip'];
                if (type === 'block')
                    this.props.adminStore.blockIP(this.state.ip)
                else
                    this.props.adminStore.unblockIP(this.state.ip)
            }
        }
        else{
            if (!domain || domain.length < 3 ) {
                validationErrors['ip'] = "Please enter a valid domain!";
                this.setState({ validationErrors });
            }
            else {
                delete validationErrors['ip'];
                if (type === 'block')
                    this.props.adminStore.blockDomain(this.state.domain)
                else
                    this.props.adminStore.unblockDomain(this.state.domain)
            }
        }

    }

    onClickCancel = () => {
        this.props.adminStore.openBlockDialog(false)
        this.setState({
            ip: '', validationErrors: {}
        })
    }

    handleChange = (e) => {
        if (this.state.ip !== '')
            this.setState({ ip: e.target.value })
        else
            this.setState({ domain: e.target.value })
    }

    render() {
        const { blockDialog, inProgress } = this.props.adminStore;
        const { classes, theme, type, filter } = this.props;
        const { validationErrors, ip, domain } = this.state
        console.log(ip, domain)
        return (
            <Dialog BackdropProps={{
                classes: {
                    root: classes.backdrop
                }
            }}
                disableBackdropClick={false} disableEscapeKeyDown={true} classes={{ paper: classes.dialog }} open={blockDialog} aria-labelledby="form-dialog-title">
                <DialogTitle>
                    <Typography className={classes.dialogHeading}>{type === 'block' ? 'Block' : 'Ublock'} {filter === 'IP' ? 'IP Address' : 'Domain'}?</Typography>
                </DialogTitle>
                <DialogContent>
                    <TextField style={{ paddingTop: 0, marginTop: 0 }}
                        required
                        id="ip-input"
                        placeholder={filter === 'IP' ? 'IP Address*' : 'Domain*'}
                        type="text"
                        name="ip"
                        margin="normal"
                        variant="filled"
                        fullWidth
                        InputProps={{
                            disableUnderline: true,
                            classes: {
                                input: classes.textFieldInput,
                            },
                        }}
                        value={ip !== '' ? ip : domain}
                        onChange={(event) => this.handleChange(event)}
                    />
                    {validationErrors.ip && <FormHelperText error style={{ display: 'flex' }} id="iperror">
                        <ReactSVG
                            beforeInjection={svg => {
                                svg.classList.add(classes.svg)
                            }}
                            src={Images.error} />{validationErrors.ip}</FormHelperText>}
                    <div className={classes.saveContainer}>
                        <Button style={{ backgroundColor: '#acb4c6' }} variant="contained" className={classes.button} type="submit" onClick={(e) => this.onClickCancel()}>
                            Cancel
                        </Button>
                        {inProgress ?
                            <Button variant="contained" className={classes.button} type="submit" style={{ backgroundColor: theme.palette.blue }}>
                                <Loader height={30} width={30} color={this.props.theme.palette.white} />
                            </Button> :
                            <Button variant="contained" className={classes.button} style={{ backgroundColor: theme.palette.blue }} type="submit" onClick={(e) => this.onClickBlock(e)}>
                                {type === 'block' ? 'Block' : 'Unblock'}
                            </Button>
                        }
                    </div>
                </DialogContent>
            </Dialog>
        )
    }

}

BlockDialog.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(adminStyles, { withTheme: true })(withRouter(BlockDialog));
